import styled from 'styled-components';

export const ButtonRowContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  margin-right: ${({ theme }) => theme.spacing.sm};
  margin-left: ${({ theme }) => theme.spacing.sm};
`;

export const RowSeparater = styled.div`
  display: flex;
  height: 120px;
  padding-top: ${({ theme }) => theme.spacing.sm};
`;

export const OptionsButtonContainer = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const OptionsButtonCustomContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
  margin: 0 ${({ theme }) => theme.spacing.l};
`;
